import { render } from "./AppTakePhoto.vue?vue&type=template&id=03cecd7b&scoped=true&ts=true"
import script from "./AppTakePhoto.vue?vue&type=script&lang=ts"
export * from "./AppTakePhoto.vue?vue&type=script&lang=ts"

import "./AppTakePhoto.vue?vue&type=style&index=0&id=03cecd7b&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cecd7b"]])

export default __exports__